export const NUMBER_OF_US = 8;
export const HOURLY_RATE = 250;
export const PRICE_PER_KM = 10;
export const DEFAULT_NUMBER_OF_CARS = 3;
export const ORIGIN = "Liptál";
